module.exports = __webpack_public_path__ + "img/canada-lung-cancer-male.89026cf4.png";